import React, { useEffect, useState } from 'react'
import { TextInput } from 'gu-ui-kit'
import { NumericFormat } from 'react-number-format'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import Decimal from 'decimal.js'

const AmountInput = ({
  setBudgetAmount,
  budget_limit,
  budget_limit_day,
  original,
  error = null,
  touched = false,
}) => {
  const [amount, setAmount] = useState(budget_limit ?? budget_limit_day)
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()
  const [touchField, setTouchedField] = useState(touched)
  const [errorField, setErrorField] = useState(error)

  useEffect(() => {
    setTouchedField(touched)
  }, [touched])

  return (
    <NumericFormat
      value={amount}
      placeholder={t(
        'campaigns_editor::budget_editor.controls_panel.budget.amount.placeholder',
      )}
      isAllowed={({ value }) => {
        if (!value) {
          return true
        } else {
          const floatVal = new Decimal(value)
          return (
            floatVal.greaterThan('0.00') &&
            floatVal.lessThanOrEqualTo('1000000000.00')
          )
        }
      }}
      customInput={TextInput}
      thousandSeparator={' '}
      allowLeadingZeros={true}
      decimalScale={2}
      decimalSeparator={'.'}
      fixedDecimalScale
      size={breakpoints.sm ? 's' : 'm'}
      onChange={(e) => {
        setErrorField(null)
        setTouchedField(false)
        setAmount(Math.abs(parseFloat(e.target.value.replace(/\s/g, ''))))
      }}
      error={errorField}
      helperText={touchField && errorField ? errorField : null}
      valueIsNumericString={true}
      onBlur={(e) => {
        setBudgetAmount(
          original,
          Math.abs(parseFloat(e.target.value.replace(/\s/g, ''))),
          budget_limit_day !== null ? 'budget_limit_day' : 'budget_limit',
        )
      }}
      suffix={' ₽'}
    />
  )
}

export default AmountInput

AmountInput.propTypes = {
  setBudgetAmount: PropTypes.func.isRequired,
  budget_limit: PropTypes.number,
  budget_limit_day: PropTypes.number,
  original: PropTypes.object.isRequired,
  error: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
  touched: PropTypes.bool,
}
